exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-tooltip[data-v-6cffabea] {\n  display: block;\n  width: 100%;\n  max-width: unset;\n  right: 0;\n}\nbutton.is-invalid[data-v-6cffabea] {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}", ""]);

// exports
